/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_A2dInputs */

const en_mk_sol_agensi_a2d = /** @type {(inputs: Mk_Sol_Agensi_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepares replies to client questions and recaps the pipeline every Friday.`)
};

const id_mk_sol_agensi_a2d = /** @type {(inputs: Mk_Sol_Agensi_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyiapkan balasan untuk pertanyaan klien dan merekap status pipeline tiap Jumat.`)
};

/**
* | output |
* | --- |
* | "Prepares replies to client questions and recaps the pipeline every Friday." |
*
* @param {Mk_Sol_Agensi_A2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_a2d = /** @type {((inputs?: Mk_Sol_Agensi_A2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_A2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_a2d(inputs)
	return en_mk_sol_agensi_a2d(inputs)
});